import React from 'react';
import PropTypes from 'prop-types';

/**
 * Modal - A wrapper that renders a standard HTML div with Bulma class names
 * 
 * This component accepts the same props as Bloomer Modal for easy migration
 */
const Modal = ({
  className = '',
  children = null,
  style = {},
  tag: Tag = 'div',
  isActive = false,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['modal'];
    
    // Add active class if modal is active
    if (isActive) {
      classes.push('is-active');
    }
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <Tag
      className={getClassNames()}
      style={style}
      {...props}
    >
      {children}
    </Tag>
  );
};

// eslint-disable-next-line react/require-default-props
Modal.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  tag: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object
  ]),
  isActive: PropTypes.bool,
};



export default Modal;
